/* Fade carousel: never intercept wheel or touch scrolling. */
class MokableHero extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const options = {signal:this.abort.signal};
    this.slides = [...this.querySelectorAll('.mkv4-hero__slide')];
    this.dots = [...this.querySelectorAll('[data-slide-index]')];
    this.index = 0; this.paused = false;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.style.setProperty('--hero-duration', `${Number(this.dataset.duration) || 800}ms`);
    this.measure = () => {
      const headers = [...document.querySelectorAll('.mk-header,.mk-announce')];
      const height = headers.reduce((sum,node)=>sum+node.getBoundingClientRect().height,0);
      this.style.setProperty('--hero-header-height', `${height}px`);
      this.closest('.mkv5-first-view')?.style.setProperty('--mkv5-top-header-height', `${height}px`);
    };
    this.resize = new ResizeObserver(this.measure);
    document.querySelectorAll('.mk-header,.mk-announce').forEach(node=>this.resize.observe(node));
    this.measure();window.addEventListener('resize',this.measure,options);
    this.querySelector('[data-prev]')?.addEventListener('click',()=>{this.show(-1);this.schedule();},options);
    this.querySelector('[data-next]')?.addEventListener('click',()=>{this.show(1);this.schedule();},options);
    this.querySelector('[data-pause]')?.addEventListener('click',()=>{this.paused=!this.paused;this.schedule();},options);
    this.dots.forEach(button=>button.addEventListener('click',()=>{
      this.show(Number(button.dataset.slideIndex)-this.index);this.schedule();
    },options));
    this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},options);
    this.addEventListener('focusout',event=>{
      if(!this.contains(event.relatedTarget)){this.focused=false;this.schedule();}
    },options);
    this.motion.addEventListener('change',()=>this.schedule(),options);
    document.addEventListener('visibilitychange',()=>this.schedule(),options);this.schedule();
  }
  schedule() {
    clearInterval(this.timer);
    const button=this.querySelector('[data-pause]');
    if(button){button.hidden=this.motion.matches;button.setAttribute('aria-pressed',String(this.paused));button.textContent=this.paused?'自動切替を再開':'自動切替を停止';}
    if(this.slides.length<2 || this.paused || this.focused || this.motion.matches || document.hidden)return;
    this.timer=setInterval(()=>this.show(1),Math.max(2000,Number(this.dataset.interval)||5000));
  }
  show(delta) {
    if(!this.slides.length)return;
    this.slides[this.index]?.classList.remove('is-active');this.slides[this.index]?.setAttribute('aria-hidden','true');
    this.index=(this.index+delta+this.slides.length)%this.slides.length;
    this.slides[this.index]?.classList.add('is-active');this.slides[this.index]?.removeAttribute('aria-hidden');
    const counter=this.querySelector('[data-counter]');if(counter)counter.textContent=`${this.index+1} / ${this.slides.length}`;
    this.dots.forEach((button,index)=>button.setAttribute('aria-current',String(index===this.index)));
  }
  disconnectedCallback(){clearInterval(this.timer);this.resize?.disconnect();this.abort?.abort();}
}
if(!customElements.get('mokable-hero'))customElements.define('mokable-hero',MokableHero);
